

















































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import HtmlEditor from "../controls/HtmlEditor.vue";
import Loading from "../general/Loading.vue";

import WorkshopJson, { WorkshopDescriptionAllowedTags } from "../../shared/WorkshopJson";
import WorkshopPriceJson from "../../shared/WorkshopPriceJson";

import Utils from "../../shared/Utils";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import PriceTemplateManualJson, { PriceTemplateManual } from "../../shared/PriceTemplateManualJson";

import { validateWorkshopJsonManagement } from "../../shared/WorkshopJson";
import { validateWorkshopJsonManagementAdd } from "../../shared/WorkshopJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import PriceTemplates from "../custom/PriceTemplates";

type keysForCachedPrices = {
  [key in keyof Pick<WorkshopPriceJson, "priceDeposit" | "priceNonDeposit" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "WorkshopsWorkshopDetails",
  components: {
    OverlayWindow,
    HtmlEditor,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    workshopId: Number,
    selectedWorkshopDetails: Object,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Utils: Utils,
      WorkshopDescriptionAllowedTags: WorkshopDescriptionAllowedTags,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      PriceTemplates: PriceTemplates as PriceTemplateManual,
      detailsMode: "",
      selectedTemplatePrices: {} as { [index: number]: any },
      cachedRegistrationBeginDateTime: "",
      cachedRegistrationEndDateTime: "",
      cachedDates: [] as {
        beginDateTime: string;
        endDateTime: string;
        beginTime: string;
        endTime: string;
      }[],
      cachedPrices: [] as keysForCachedPrices[],
      selectedWorkshopId: null as number | null,
      workshopDetails: null as WorkshopJson | null,
      hasChanges: false,
      hintChanged: {
        program: false as boolean,
        staff: false as boolean,
        restrictStaff: false as boolean,
        estimatedChildrenCount: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<WorkshopJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initWorkshopDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.setCachedDates();
  },
  methods: {
    initWorkshopDetails() {
      this.selectedWorkshopId = this.workshopId;

      this.loadWorkshopDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.setCachedDates();
      this.setCachedPrices();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadWorkshopDetails() {
      if (this.selectedWorkshopId != null) {
        this.workshopDetails = this.selectedWorkshopDetails;
      } else {
        this.workshopDetails = {
          ID: null,
          title: "",
          description: "",
          remarks: "",
          dates: [
            {
              beginDateTime: "",
              endDateTime: "",
            },
          ],
          prices: [this.getDefaultPrice()],
          allowRegistration: false,
          registrationBeginDateTime: "",
          registrationEndDateTime: "",
          registrationMaximumCount: 1,
          waitingListMaximumCount: 0,
        };

        this.markPriceAsNew();
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultPrice(): WorkshopPriceJson {
      let cancellationRemarks = "";

      if (this.PriceTemplates.hasOwnProperty("workshopPrices")) {
        cancellationRemarks = (this.PriceTemplates.holidaysPrices.default as PriceTemplateManualJson)
          .cancellationRemarks;
      }

      return {
        title: "",
        remarks: "",
        cancellationFee: 0,
        cancellationRemarks,
        priceDeposit: 0,
        priceNonDeposit: 0,
      };
    },

    //START set cached data

    setCachedDates() {
      if (this.workshopDetails != null) {
        if (this.workshopDetails["registrationBeginDateTime"] != "") {
          var d = new Date(this.workshopDetails["registrationBeginDateTime"]);

          if (this.supportsDatePicker) {
            this.cachedRegistrationBeginDateTime = DateFormatter.formatISODate(d);
          } else {
            if (d != null) {
              this.cachedRegistrationBeginDateTime = DateFormatter.formatDateMedium(d);
            }
          }
        }

        if (this.workshopDetails["registrationEndDateTime"] != "") {
          var d = new Date(this.workshopDetails["registrationEndDateTime"]);

          if (this.supportsDatePicker) {
            this.cachedRegistrationEndDateTime = DateFormatter.formatISODate(d);
          } else {
            if (d != null) {
              this.cachedRegistrationEndDateTime = DateFormatter.formatDateMedium(d);
            }
          }
        }

        for (let i = 0; i < this.workshopDetails.dates.length; i++) {
          this.cachedDates[i] = {
            beginDateTime: "",
            endDateTime: "",
            beginTime: "",
            endTime: "",
          };

          if (this.workshopDetails.dates[i].beginDateTime != "") {
            var d = new Date(this.workshopDetails.dates[i].beginDateTime);

            if (this.supportsDatePicker) {
              this.cachedDates[i].beginDateTime = DateFormatter.formatISODate(d);
            } else {
              if (d != null) {
                this.cachedDates[i].beginDateTime = DateFormatter.formatDateMedium(d);
              }
            }

            this.cachedDates[i].beginTime = this.DateFormatter.formatTime(d);
          }

          if (this.workshopDetails.dates[i].endDateTime != "") {
            var d = new Date(this.workshopDetails.dates[i].endDateTime);

            if (this.supportsDatePicker) {
              this.cachedDates[i].endDateTime = DateFormatter.formatISODate(d);
            } else {
              if (d != null) {
                this.cachedDates[i].endDateTime = DateFormatter.formatDateMedium(d);
              }
            }

            this.cachedDates[i].endTime = this.DateFormatter.formatTime(d);
          }
        }
      }
    },

    /* setCachedPrices() {
         if (this.workshopDetails != null) {
            let k = this.cachedPrices
            let i: keyof typeof k

            for (i in this.cachedPrices) {
               let price = this.workshopDetails[i]
                  ?.toString()
                  .padStart(3, "0")
                  .replace(/(\d{2,2})$/g, ",$1")
                  .replace("NaN", "")

               if (price !== undefined) {
                  this.cachedPrices[i] = price
               }
            }
         }
      }, */

    setCachedPrices() {
      if (this.workshopDetails != null) {
        for (let i = 0; i < this.workshopDetails.prices.length; i++) {
          let prices = {
            priceDeposit: "0,00",
            priceNonDeposit: "0,00",
            cancellationFee: "0,00",
          } as keysForCachedPrices;

          let k = prices;
          let j: keyof typeof k;

          for (j in prices) {
            prices[j] = this.getFormatPrice(this.workshopDetails.prices[i][j]);
          }

          this.cachedPrices.push(prices);
        }
      }
    },

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Kurs hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Kurs bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Kurs";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.workshopDetails != null) {
        this.validation = validateWorkshopJsonManagement(this.workshopDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //prices

    addPrice() {
      if (this.workshopDetails != null) {
        this.cachedPrices.push({
          cancellationFee: "0,00",
          priceDeposit: "0,00",
          priceNonDeposit: "0,00",
        });
        this.workshopDetails.prices.push(this.getDefaultPrice());

        this.markPriceAsNew();
      }
    },

    deletePrice(index: number) {
      if (this.workshopDetails != null && this.workshopDetails.prices != null) {
        this.workshopDetails.prices.splice(index, 1);
        this.cachedPrices.splice(index, 1);

        delete this.toValidate["prices-" + index];
      }
    },

    markPriceAsNew() {
      if (this.workshopDetails != null) {
        let index = this.workshopDetails.prices.length - 1;
        this.selectedTemplatePrices[index] = null;
      }
    },

    setTemplatePriceRemarks(priceIndex: number) {
      if (this.workshopDetails != null) {
        if (this.selectedTemplatePrices[priceIndex] != null && this.PriceTemplates.hasOwnProperty("workshopPrices")) {
          const templates = this.PriceTemplates.workshopPrices.templates as PriceTemplateManualJson[];

          this.workshopDetails.prices[priceIndex].title = templates[this.selectedTemplatePrices[priceIndex]].title;
          this.workshopDetails.prices[priceIndex].remarks = templates[this.selectedTemplatePrices[priceIndex]].remarks;
          this.workshopDetails.prices[priceIndex].cancellationRemarks =
            templates[this.selectedTemplatePrices[priceIndex]].cancellationRemarks;
        } else {
          this.workshopDetails.prices[priceIndex].title = "";
          this.workshopDetails.prices[priceIndex].remarks = "";
          this.workshopDetails.prices[priceIndex].cancellationRemarks = "";
        }
      }
    },

    //START set input data (where data be cached)

    setRegistrationBeginDateTime() {
      if (this.workshopDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = DateFormatter.formatUSDate(new Date(this.cachedRegistrationBeginDateTime));
        } else {
          if (this.cachedRegistrationBeginDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedRegistrationBeginDateTime);

            if (d != null) {
              date = DateFormatter.formatUSDate(d);
            }
          }
        }

        if (isNaN(new Date(date).getTime())) {
          this.workshopDetails.registrationBeginDateTime = "";
        } else {
          var dateTime = new Date(date);

          if (this.workshopDetails.registrationBeginDateTime != "") {
            let time = DateFormatter.formatTime(new Date(this.workshopDetails.registrationBeginDateTime));

            dateTime = new Date(date + " " + time);
          }

          this.workshopDetails.registrationBeginDateTime = DateFormatter.formatISODateTime(dateTime);
        }
      }
    },

    setRegistrationEndDateTime() {
      if (this.workshopDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = DateFormatter.formatUSDate(new Date(this.cachedRegistrationEndDateTime));
        } else {
          if (this.cachedRegistrationEndDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedRegistrationEndDateTime);

            if (d != null) {
              date = DateFormatter.formatUSDate(d);
            }
          }
        }

        if (isNaN(new Date(date).getTime())) {
          this.workshopDetails.registrationEndDateTime = "";
        } else {
          var dateTime = new Date(date);

          if (this.workshopDetails.registrationEndDateTime != "") {
            let time = DateFormatter.formatTime(new Date(this.workshopDetails.registrationEndDateTime));

            dateTime = new Date(date + " " + time);
          }

          this.workshopDetails.registrationEndDateTime = DateFormatter.formatISODateTime(dateTime);
        }
      }
    },

    /* formatAndSetCachedPrices(key: keyof keysForCachedPrices) {
         if (this.workshopDetails != null) {
            let price = this.cachedPrices[key].replace(".", ",")

            if (!price.includes(",")) {
               price += ",00"
            }

            if (!price.match(/^\d{1,}(,\d{2})?$/)) {
               price = ""
            }

            this.cachedPrices[key] = price
            this.workshopDetails[key] = parseInt(price.replace(/[\D]/g, ""))
         }
      }, */

    formatAndSetCachedPrice(index: number, key: keyof keysForCachedPrices) {
      if (index != null && this.workshopDetails != null) {
        let price = this.cachedPrices[index][key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[index][key] = price;
        this.workshopDetails.prices[index][key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    setDates(index: any) {
      if (index != null && this.workshopDetails != null) {
        let k = this.cachedDates[index];
        let i: keyof typeof k;

        for (i in k) {
          if (this.cachedDates[index].endDateTime == "") {
            this.cachedDates[index].endDateTime = this.cachedDates[index].beginDateTime;
          }

          var beginDate = "";
          var endDate = "";

          if (this.supportsDatePicker) {
            //beginDateTime
            beginDate = DateFormatter.formatUSDate(new Date(this.cachedDates[index].beginDateTime));

            //endDateTime
            endDate = DateFormatter.formatUSDate(new Date(this.cachedDates[index].endDateTime));
          } else {
            //beginDateTime
            if (this.cachedDates[index].beginDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedDates[index].beginDateTime);

              if (d != null) {
                beginDate = DateFormatter.formatUSDate(d);
              }
            }

            //endDateTime
            if (this.cachedDates[index].endDateTime.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedDates[index].endDateTime);

              if (d != null) {
                endDate = DateFormatter.formatUSDate(d);
              }
            }
          }

          //beginDateTime Time
          if (isNaN(new Date(beginDate).getTime())) {
            this.workshopDetails.dates[index].beginDateTime = "";
          } else {
            let beginDateTime = new Date(beginDate);

            if (this.cachedDates[index].beginTime != "") {
              beginDateTime = new Date(beginDate + " " + this.cachedDates[index].beginTime);
            }

            this.workshopDetails.dates[index].beginDateTime = DateFormatter.formatISODateTime(beginDateTime);

            this.cachedDates[index].beginTime = DateFormatter.formatTime(beginDateTime);
          }

          //endDateTime Time
          if (isNaN(new Date(endDate).getTime())) {
            this.workshopDetails.dates[index].endDateTime = "";
          } else {
            let endDateTime = new Date(endDate);

            if (this.cachedDates[index].endTime != "") {
              endDateTime = new Date(endDate + " " + this.cachedDates[index].endTime);
            }

            this.workshopDetails.dates[index].endDateTime = DateFormatter.formatISODateTime(endDateTime);

            this.cachedDates[index].endTime = DateFormatter.formatTime(endDateTime);
          }
        }
      }
    },

    formatDateTimes(index: any) {
      //begin
      let beginTime = this.cachedDates[index].beginTime.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

      if (beginTime.match(/^\d{2,2}:\d{2,2}$/g)) {
        this.cachedDates[index].beginTime = beginTime;
      }

      //end
      let endTime = this.cachedDates[index].endTime.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

      if (beginTime.match(/^\d{2,2}:\d{2,2}$/g)) {
        this.cachedDates[index].endTime = endTime;
      }
    },

    //END set input data (where data be cached)

    addDate() {
      if (this.workshopDetails != null) {
        this.cachedDates.push({ beginDateTime: "", endDateTime: "", beginTime: "", endTime: "" });
        this.workshopDetails.dates.push({ beginDateTime: "", endDateTime: "" });
      }
    },

    deleteDate(index: number) {
      if (this.workshopDetails != null && this.workshopDetails.dates != null) {
        this.workshopDetails.dates.splice(index, 1);
        this.cachedDates.splice(index, 1);

        delete this.toValidate["dates-" + index];
      }
    },

    async addNewWorkshop() {
      if (this.workshopDetails != null) {
        this.loadingGeneral = true;

        this.validation = validateWorkshopJsonManagementAdd(this.workshopDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.workshopDetails = await this.restClient.addWorkshop(this.workshopDetails);
            alert("Der Kurs wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Der Kurs konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveWorkshopDetails() {
      if (this.workshopDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateWorkshopJsonManagement(this.workshopDetails);
          //todo ###END
          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedWorkshopDetails = await this.restClient.updateWorkshop(this.workshopDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteWorkshop() {
      if (this.selectedWorkshopId != null) {
        let c = confirm("Wollen Sie diesen Kurs wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteWorkshop(this.selectedWorkshopId);
              this.closeDetails();
              alert("Der Kurs wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    workshopDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    parseRegistrationMaximumCount: {
      get(): number | undefined {
        if (this.workshopDetails != null) {
          return this.workshopDetails.registrationMaximumCount;
        }
      },
      set(value: string) {
        if (this.workshopDetails != null) {
          this.workshopDetails.registrationMaximumCount = parseInt(value);
        }
      },
    },

    parseWaitingListMaximumCount: {
      get(): number | undefined {
        if (this.workshopDetails != null) {
          return this.workshopDetails.waitingListMaximumCount;
        }
      },
      set(value: string) {
        if (this.workshopDetails != null) {
          this.workshopDetails.waitingListMaximumCount = parseInt(value);
        }
      },
    },

    formatRegistrationBeginTime: {
      get(): string | undefined {
        if (this.workshopDetails != null) {
          let d = new Date(this.workshopDetails.registrationBeginDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return DateFormatter.formatTime(d);
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.workshopDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.workshopDetails.registrationBeginDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.workshopDetails.registrationBeginDateTime));
            this.workshopDetails.registrationBeginDateTime = DateFormatter.formatISODateTime(
              new Date(date + " " + time)
            );
          }
        }
      },
    },

    formatRegistrationEndTime: {
      get(): string | undefined {
        if (this.workshopDetails != null) {
          let d = new Date(this.workshopDetails.registrationEndDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return time;
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.workshopDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.workshopDetails.registrationEndDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.workshopDetails.registrationEndDateTime));
            this.workshopDetails.registrationEndDateTime = DateFormatter.formatISODateTime(new Date(date + " " + time));
          }
        }
      },
    },
  },
});
